import { baseApi } from "./base.api";

export const pageMetaApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    fetchPageMeta: build.query({
      query: (params) => ({ url: "/page-meta/fetch", method: "GET", params }),
      providesTags: ["PageMeta"],
    }),
    fetchPageMetaAll: build.query({
      query: () => ({ url: "/page-meta/fetch/all", method: "GET" }),
      providesTags: ["PageMeta"],
    }),
    fetchTrashedPageMeta: build.query({
      query: (params) => ({ url: "/page-meta/fetch/trashed", method: "GET", params }),
      providesTags: ["PageMeta"],
    }),
    fetchPageMetaById: build.query({
      query: (id) => ({ url: `/page-meta/fetch/${id}`, method: "GET" }),
      providesTags: ["PageMeta"],
    }),
    createPageMeta: build.mutation({
      query: (body) => ({ url: "/page-meta/create", method: "POST", body }),
      invalidatesTags: ["PageMeta"],
    }),
    updatePageMeta: build.mutation({
      query: ({ id, body }) => ({ url: `/page-meta/update/${id}`, method: "PUT", body }),
      invalidatesTags: ["PageMeta"],
    }),
    changePageMetaStatus: build.mutation({
      query: (id) => ({ url: `/page-meta/status/${id}`, method: "PUT" }),
      invalidatesTags: ["PageMeta"],
    }),
    restorePageMeta: build.mutation({
      query: (id) => ({ url: `/page-meta/restore/${id}`, method: "PUT" }),
      invalidatesTags: ["PageMeta"],
    }),
    bulkRestorePageMeta: build.mutation({
      query: (body) => ({ url: "/page-meta/bulk-restore", method: "POST", body }),
      invalidatesTags: ["PageMeta"],
    }),
    deletePageMeta: build.mutation({
      query: (id) => ({ url: `/page-meta/delete/${id}`, method: "DELETE" }),
      invalidatesTags: ["PageMeta"],
    }),
    bulkDeletePageMeta: build.mutation({
      query: (body) => ({ url: "/page-meta/bulk-delete", method: "POST", body }),
      invalidatesTags: ["PageMeta"],
    }),
    destroyPageMeta: build.mutation({
      query: (id) => ({ url: `/page-meta/destroy/${id}`, method: "DELETE" }),
      invalidatesTags: ["PageMeta"],
    }),
    bulkDestroyPageMeta: build.mutation({
      query: (body) => ({ url: "/page-meta/bulk-destroy", method: "POST", body }),
      invalidatesTags: ["PageMeta"],
    }),
  }),
});

export const {
  useFetchPageMetaQuery,
  useFetchPageMetaAllQuery,
  useFetchTrashedPageMetaQuery,
  useFetchPageMetaByIdQuery,
  useCreatePageMetaMutation,
  useUpdatePageMetaMutation,
  useChangePageMetaStatusMutation,
  useRestorePageMetaMutation,
  useBulkRestorePageMetaMutation,
  useDeletePageMetaMutation,
  useBulkDeletePageMetaMutation,
  useDestroyPageMetaMutation,
  useBulkDestroyPageMetaMutation,
} = pageMetaApi;
